import ACTIVITY_TYPE from '../../default/activities/Activities'
import * as DEFAULT from '../../default/activities/ListSettings'

export const MHE_STATUS_OPTIONS = [
    ...DEFAULT.STATUS_OPTIONS,
];

export const MHE_PAGINATION_OPTIONS = [
    { value: '6', label: '6' },
    ...DEFAULT.PAGINATION_OPTIONS,
];

export const MHE_SORTING_OPTIONS = [
    ...DEFAULT.SORTING_OPTIONS,
    { value: 'isbn&asc', label: 'ISBN: low to high' },
    { value: 'isbn&desc', label: 'ISBN: high to low' },
];

// refactor later: create an assessment folder and move there
export const MHE_SORTING_OPTIONS_ASSESSMENTS = [
    { value: 'id&asc', label: 'Id: low to high' },
    { value: 'id&desc', label: 'Id: high to low' },
    { value: 'title&asc', label: 'Name: A to Z' },
    { value: 'title&desc', label: 'Name: Z to A' },
];

export const MHE_LANGUAGES_OPTIONS_SHOW_ALL = [
    ...DEFAULT.LANGUAGES_OPTIONS_SHOW_ALL,
    { value: 'ca-ES', label: 'Català' },
    { value: 'eu-ES', label: 'Euskara' },
    { value: 'gl-ES', label: 'Galego' },
];

export const MHE_LANGUAGES_OPTIONS = [
    ...DEFAULT.LANGUAGES_OPTIONS,
    { value: 'ca-ES', label: 'Català' },
    { value: 'eu-ES', label: 'Euskara' },
    { value: 'gl-ES', label: 'Galego' },
];

export const MHE_UNITS_OPTIONS = [
    { value: '00', label: '00' },
    { value: '01', label: '01' },
    { value: '02', label: '02' },
    { value: '03', label: '03' },
    { value: '04', label: '04' },
    { value: '05', label: '05' },
    { value: '06', label: '06' },
    { value: '07', label: '07' },
    { value: '08', label: '08' },
    { value: '09', label: '09' },
    { value: '10', label: '10' },
    { value: '11', label: '11' },
    { value: '12', label: '12' },
    { value: '13', label: '13' },
    { value: '14', label: '14' },
    { value: '15', label: '15' },
    { value: '16', label: '16' },
    { value: '17', label: '17' },
    { value: '18', label: '18' },
    { value: '19', label: '19' },
    { value: '20', label: '20' },
    { value: '21', label: '21' },
    { value: '22', label: '22' },
    { value: '23', label: '23' },
    { value: '24', label: '24' },
    { value: '25', label: '25' },
    { value: '26', label: '26' },
    { value: '27', label: '27' },
    { value: '28', label: '28' },
    { value: '29', label: '29' },
    { value: '30', label: '30' },
    { value: '31', label: '31' },
    { value: '32', label: '32' },
    { value: '33', label: '33' },
    { value: '34', label: '34' },
    { value: '35', label: '35' },
    { value: '36', label: '36' },
    { value: '37', label: '37' },
    { value: '38', label: '38' },
    { value: '39', label: '39' },
    { value: '40', label: '40' },
    { value: '41', label: '41' },
    { value: '42', label: '42' },
    { value: '43', label: '43' },
    { value: '44', label: '44' },
    { value: '45', label: '45' },
    { value: '46', label: '46' },
    { value: '47', label: '47' },
    { value: '48', label: '48' },
    { value: '49', label: '49' },
    { value: '50', label: '50' },
];

export const MHE_ACTIVITIES_LIST_ALL_TYPES = [
    { value: 'exam', label: 'Exam' },
    ...DEFAULT.ACTIVITIES_LIST_ALL_TYPES,
    { value: ACTIVITY_TYPE.MATCH, label: 'Match' },
    { value: ACTIVITY_TYPE.INPUT, label: 'Input' },
    { value: ACTIVITY_TYPE.INPUT_LONG, label: 'Input long' },
    { value: ACTIVITY_TYPE.FIT_WORD, label: 'Fit word' },
    { value: ACTIVITY_TYPE.RANK, label: 'Rank' },
];
